import { render } from "./FilterCategory.vue?vue&type=template&id=599518d9&ts=true"
import script from "./FilterCategory.vue?vue&type=script&lang=ts"
export * from "./FilterCategory.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__